/* Collection pages: replace numbered pagination with load-as-you-scroll.

   Dawn paginates the grid, so a 95-print collection stopped at 36 and pushed
   people to a page 2 most of them never opened.

   Two things about THIS theme that the obvious implementation gets wrong:

   1. There is no #shopify-section-... wrapper around the grid on the
      collection template, so the section id has to be read off the
      "section-<id>-padding" class instead.
   2. The pagination snippet labels its forward arrow "pagination__item--prev"
      -- so a[rel=next] and .pagination__item--next both find nothing. The next
      URL is therefore worked out from the ?page= numbers instead of a class.

   The next page is fetched through the Section Rendering API against the real
   collection URL, so filters and sort order carry over untouched. */
(function(){
  'use strict';

  var CSS='.cb-mbar{display:flex;flex-direction:column;align-items:center;gap:9px;padding:14px 0 4px}'+
          '.cb-mbtn{min-height:48px;padding:0 26px;border-radius:999px;border:1.5px solid rgba(var(--color-foreground),.28);background:none;color:rgb(var(--color-foreground));font-size:15px;font-weight:600;cursor:pointer;transition:border-color .15s ease,transform .15s ease}'+
          '.cb-mbtn:hover{border-color:rgba(var(--color-foreground),.6);transform:translateY(-1px)}'+
          '.cb-mbtn[disabled]{opacity:.5;cursor:default;transform:none}'+
          '.cb-mbtn[hidden]{display:none}'+
          '.cb-mcount{font-size:12.5px;color:rgba(var(--color-foreground),.55);font-variant-numeric:tabular-nums}';

  function injectCss(){
    if(document.getElementById('cb-more-css'))return;
    var s=document.createElement('style');
    s.id='cb-more-css';
    s.textContent=CSS;
    document.head.appendChild(s);
  }

  function sectionId(container){
    var sec=container.closest('[id^="shopify-section-"]');
    if(sec)return sec.id.replace('shopify-section-','');
    var all=document.querySelectorAll('[class*="-padding"]');
    for(var i=0;i<all.length;i++){
      var cn=all[i].className;
      if(typeof cn!=='string')continue;
      var m=cn.match(/section-([^\s]+?)-padding/);
      if(m&&m[1].indexOf('product-grid')>-1)return m[1];
    }
    return null;
  }

  /* Work the next page out from the ?page= numbers, not from a class name. */
  function nextUrl(scope){
    if(!scope)return null;
    var cur=scope.querySelector('.pagination__item--current');
    var n=cur?parseInt((cur.textContent||'').trim(),10):1;
    if(!n||isNaN(n))n=1;

    var links=scope.querySelectorAll('a.pagination__item, .pagination__item');
    var best=null,bestN=Infinity;
    for(var i=0;i<links.length;i++){
      var href=links[i].getAttribute&&links[i].getAttribute('href');
      if(!href)continue;
      var m=href.match(/[?&]page=(\d+)/);
      if(!m)continue;
      var p=parseInt(m[1],10);
      if(p>n&&p<bestN){bestN=p;best=href;}
    }
    return best;
  }

  function totalCount(){
    var el=document.querySelector('#ProductCount, #ProductCountDesktop, .product-count__text, .collection-product-count');
    if(!el)return 0;
    var m=(el.textContent||'').replace(/,/g,'').match(/\d+/);
    return m?parseInt(m[0],10):0;
  }

  function setup(){
    var container=document.getElementById('ProductGridContainer');
    if(!container||container.dataset.cbMore)return;

    var grid=document.getElementById('product-grid');
    if(!grid)return;

    var pagWrap=container.querySelector('.pagination-wrapper')||document.querySelector('.pagination-wrapper');
    var href=nextUrl(pagWrap);
    if(!href)return;                    /* single page: leave the markup alone */

    var sid=sectionId(container);
    if(!sid)return;

    container.dataset.cbMore='1';
    injectCss();

    /* Keep the real pagination in the DOM for crawlers, out of the way. */
    pagWrap.style.display='none';

    var bar=document.createElement('div');
    bar.className='cb-mbar';
    bar.innerHTML='<button type="button" class="cb-mbtn">Show more</button><span class="cb-mcount"></span>';
    (pagWrap.parentElement||container).insertBefore(bar,pagWrap);

    var btn=bar.querySelector('.cb-mbtn');
    var count=bar.querySelector('.cb-mcount');
    var total=totalCount();
    var loading=false;

    function shown(){ return grid.children.length; }

    function paint(){
      count.textContent = total ? ('Showing '+shown()+' of '+total) : '';
      btn.hidden=!href;
      btn.disabled=loading;
      btn.textContent=loading?'Loading…':'Show more';
    }

    function loadNext(){
      if(loading||!href)return;
      loading=true;
      paint();

      var url=href+(href.indexOf('?')>-1?'&':'?')+'section_id='+sid;
      fetch(url)
        .then(function(r){ if(!r.ok)throw new Error(r.status); return r.text(); })
        .then(function(html){
          var box=document.createElement('div');
          box.innerHTML=html;

          var ng=box.querySelector('#product-grid');
          if(ng){ while(ng.firstElementChild) grid.appendChild(ng.firstElementChild); }

          href=nextUrl(box.querySelector('.pagination-wrapper')||box);
          if(!total)total=totalCount();
          loading=false;
          paint();
        })
        .catch(function(){
          loading=false;
          btn.disabled=false;
          btn.textContent='Could not load more — tap to retry';
        });
    }

    btn.addEventListener('click',loadNext);

    var t=0;
    function onScroll(){
      if(t)return;
      t=setTimeout(function(){
        t=0;
        if(!href||loading)return;
        var r=bar.getBoundingClientRect();
        if(r.top < (window.innerHeight||0)+800) loadNext();
      },140);
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});

    paint();
    onScroll();
  }

  /* The facet form rewrites the inside of #ProductGridContainer when a filter
     or sort changes, which wipes our bar. Watch only the container's own
     children -- our appends land deeper, so this cannot loop. */
  function watch(){
    var container=document.getElementById('ProductGridContainer');
    if(!container||container.dataset.cbWatch)return;
    container.dataset.cbWatch='1';
    try{
      var mo=new MutationObserver(function(){
        var c=document.getElementById('ProductGridContainer');
        if(!c)return;
        if(!c.querySelector('.cb-mbar')){
          delete c.dataset.cbMore;
          setup();
        }
      });
      mo.observe(container,{childList:true});
    }catch(e){}
  }

  function boot(){ try{ setup(); watch(); }catch(e){} }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
  window.addEventListener('popstate',function(){ setTimeout(boot,400); });
})();
